import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'perf',
  `
  RECORD_TIME_TO_MOUNT
  `
);
